import React, { useState, useEffect } from "react";
import TopNav from "../TopNav/TopNav";
import Header from "../Header/Header";
import "./Orders.css";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaTimesCircle } from "react-icons/fa";
import axios from "axios";
import { BackToscreen } from "./Orders";
import { ToggleMenu } from "./UserProfile";
import NewHeader from "../NewHeader/NewHeader";
import "../Plan-detail/planAddress.css";
import { AiFillInfoCircle, AiOutlineArrowLeft } from "react-icons/ai";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useDispatch, useSelector, connect } from "react-redux";
import { useHistory } from "react-router";
import Loader from "../Loader/Loader";
import { FiEdit } from "react-icons/fi";
import { Scroll } from "../Scroll function/scroll";
import {
  getAllAddress,
  getCartDetails,
  getAreaPincode,
  postNewAddress,
  editAddressForm,
  deleteAddress,
} from "../../Redux/Actions";
import Footer from "../Footer/Footer";
import { getMapMyIndiaAccessToken } from "../../Redux/Actions";

const MyAddresses = (props) => {
  const [newName, setNewName] = useState("");
  const [newNameError, setNewNameError] = useState("");
  const [Phonenum, setPhonenum] = useState("");
  const [phonenumError, setPhonenumError] = useState("");
  const [house_Numbeer, setHouseNumber] = useState("");
  const [deleteid, setDeleteId] = useState("");
  const [street_name, setstreet_name] = useState("");

  const [booking_for, setbooking_for] = useState("");

  const [address_line2, setAddress_line2] = useState("");
  const dispatch = useDispatch();
  const [editId, setEditId] = useState("");
  const [areApin, setpin] = useState("");
  const [displayCityList, setDisplay] = useState(false);
  // for the validation
  // const [validationField, setValidationField] = useState(false)

  useEffect(() => {
    Scroll();
    const datekey = JSON.parse(localStorage.getItem("user"));
    console.log(datekey);
    // const token = datekey.token;
    dispatch(getCartDetails(datekey.token));
    dispatch(getAllAddress(datekey.token));
  }, [areApin]);

  //pincode state
  const addressData = useSelector((state) => state.addressReducer);

  const { loading, addresss } = addressData;

  const cartDetails = useSelector((state) => state.CartReducer);

  const { loading: cartLoading, cartDetails: cartdata } = cartDetails;

  //pincode details
  const pincodeDetails = useSelector((state) => state.areaPincodeReducer);

  const { loading: pincodeLoading, areaPincode } = pincodeDetails;

  console.log("pincode details", pincodeDetails);
  //toggleer
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [customer_landmark, setCustomerLandmark] = useState("");
  //const pincode handler
  const handelPincode = (e) => {
    setpin(e.target.value);
    setPinList(true);
  };
  const [cityList, setCityList] = useState([]);
  const [pinList, setPinList] = useState(false);
  const [finalPin, setfinalPin] = useState("");

  const [pintofrontend, setpintofrontend] = useState("");

  const handelPincodeList = (pincode, pinId) => {
    setpin(pincode);
    console.log("PINCODE", pincode, pinId);
    setfinalPin(pinId);
    setPinList(false);
    setpintofrontend(pincode);
  };

  const successFun = () => {
    const datekey = JSON.parse(localStorage.getItem("user"));
    console.log(datekey);
    // const token = datekey.token;

    Scroll();
    setNewName("");
    setPhonenum("");
    setHouseNumber("");
    setstreet_name("");
    setbooking_for("");
    setfinalPin("");
    setpin("");
    setTimeout(() => {
      dispatch(getCartDetails(datekey.token));
      dispatch(getAllAddress(datekey.token));
      setShowAddressForm(false);
    }, 2000);
  };

  const successAdd = () => {
    const datekey = JSON.parse(localStorage.getItem("user"));
    console.log(datekey);
    // const token = datekey.token;

    Scroll();
    setNewName("");
    setPhonenum("");
    setHouseNumber("");
    setstreet_name("");
    setbooking_for("");
    setfinalPin("");
    setpin("");

    dispatch(getCartDetails(datekey.token));
    dispatch(getAllAddress(datekey.token));
    setShowAddressForm(false);
  };

  const sendId = (values) => {
    setEditId(values.id);
    setShowAddressForm(!showAddressForm);
    console.log(values, "edit id is");
    setNewName(values.name);
    setAddress_line2(values.address_line2);
    setPhonenum(values.mobile);
    setHouseNumber(values.address_line1);
    setstreet_name(values.street_name);
    setbooking_for(values.booking_for);
    setfinalPin(values.areapincode);
    setDeleteId(values.id);

    setCustomerLandmark(values.house_number);
    //  areaPincode &&   areaPincode.results && areaPincode.results.filter((pincode) => {
    //     setpin(pincode.pincode == values.areaPincode);
    //   })
  };

  // Validation field
  const handelPhonenum = (e) => {
    setPhonenum(e.target.value);
    let characterRegex = /^[0-9]{1}$/g;
    let mb = /^[0-9\b]+$/;
    setPhonenumError("");
    if (e.target.value.match(characterRegex)) {
      setPhonenumError("Enter a valid number");
    }
    if (e.target.value.length != 10) {
      setPhonenumError("Enter a valid number");
    }
    if (e.target.value.length != 10 && mb.test(e.target.value) == true) {
      setPhonenumError("Enter a valid number.");
    }
    if (
      e.target.value.length == 10 &&
      e.target.value.charAt(0) >= 6 &&
      mb.test(e.target.value) == true
    ) {
      setPhonenumError("");
    }
    if (e.target.value == "") {
      setPhonenumError("");
    }
    // if(phonenumError !== "") {
    //   setValidationField(true)
    // }
  };

  const setInputcity = (val) => {
    setCustomerLandmark(val);
    setDisplay(false);
  };

  useEffect(() => {
    const datakey = JSON.parse(localStorage.getItem("user"));
    if (!datakey) {
      history.push({
        pathname: `/login`,
        pushToUrl: "myaddresses",
      });
    }
  }, []);

  const handelNewName = (e) => {
    setNewName(e.target.value);
    const characterRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
    setNewNameError("");

    if (!e.target.value.match(characterRegex)) {
      setNewNameError("invalid name");
    }
    if (e.target.value == "") {
      setNewNameError("");
    }
    // if(newNameError !== "") {
    //   setValidationField(true)
    // }
  };

  const AddNewAddress = (e) => {
    e.preventDefault();
    // setDeleteId("");

    ///
    const addressObject = {
      address_line1: house_Numbeer,
      address_line2: address_line2,
      areapincode: parseInt(finalPin),
      booking_for: booking_for,
      house_number: customer_landmark,
      mobile: Phonenum,
      name: newName,
      street_name: street_name,
    };

    const datakey = JSON.parse(localStorage.getItem("user"));
    const token = datakey.token;

    // if(newNameError !== ""){
    //   window.alert("Please enter a valid name")
    // }

    if (editId !== "") {
      console.log(`address edited with id ${editId}`, addressObject);
      dispatch(editAddressForm(token, addressObject, editId, successFun));
    } else {
      dispatch(postNewAddress(token, addressObject, successAdd));
      console.log("new address added", addressObject);
    }
  };

  function deleteAddressFunnction(id) {
    console.log("addredd");
    setNewName("");
    setPhonenum("");
    setHouseNumber("");
    setstreet_name("");
    setbooking_for("");
    setfinalPin("");
    setpin("");
    // setShowAddressForm(true);

    if (id != "") {
      setPhonenumError("");
      const datekey = JSON.parse(localStorage.getItem("user"));
      dispatch(deleteAddress(datekey.token, id, successFun));
    }
  }

  const openNewform = () => {
    setShowAddressForm(!showAddressForm), Scroll();
    setNewName("");
    setPhonenum("");
    setHouseNumber("");
    setstreet_name("");
    setbooking_for("");
    setfinalPin("");
    setEditId("");
    setpin("");
    setCustomerLandmark("");
    setAddress_line2("");
    setNewNameError("");
    setPhonenumError("");
  };

  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal.token;
    props.getMapMyIndiaAccessToken(token);
  }, []);

  const locationAutoCompleteSearch = (e) => {
    if (
      !props.LoadingAccessToken &&
      e.target.value?.length > 2 &&
      e.nativeEvent.data != null
    ) {
      setCityList([]);
      const urlForMap = `https://atlas.mapmyindia.com/api/places/search/json?query=${e.target.value}&access_token=${props.Accesstoken}&tokenizeAddress=true`;
      axios
        .get(urlForMap)
        .then((res) => {
          res.data.suggestedLocations.map((item) => {
            setCityList((lst) => [...lst, item.placeAddress]);
            console.log(cityList);
            console.log(item.placeAddress);
          });
        })
        .catch((err) => {
          console.log(err);
        });
      // console.log(e.target.value,data,"Here is value")
      setDisplay(true);
      console.log(displayCityList, "<=====");
    } else {
      setDisplay(false);
    }
    setCustomerLandmark(e.target.value);
  };
  return (
    <div>
      <NewHeader />

      <div className="activeDashboard">
        <div className="dashboard_content">
          <div className="back_btn">
            {/* <Link to="/userdashboard">
              <FaArrowLeft /> Back to dashboard
            </Link> */}
          </div>
          <BackToscreen title="User Address" />
          <div className="fleex_rows fleex_rowsMarginTop">
            <div className="dashboard_contentLeft">
              <ToggleMenu isMyAddresses={true} />
            </div>

            <div className="dashboard_contentRight">
              {/* ADD OR EDIT FORM BELOW */}
              {showAddressForm ? (
                <div className="addressFormDiv addressFormDiv1">
                  <form onSubmit={AddNewAddress}>
                    <div className="forBorder">
                      <div className="d_end">
                        <div
                          className="deletIcon"
                          onClick={() => setShowAddressForm(false)}
                        >
                          <FaTimesCircle className="deletlogo" />
                        </div>
                      </div>

                      <label className="halfWidthinput">
                        <p>NAME</p>{" "}
                        <input
                          type="text"
                          placeholder="Enter Name"
                          value={newName}
                          onChange={handelNewName}
                          required
                        ></input>{" "}
                        <br></br>
                        <span id="errorMessage">{newNameError}</span>
                      </label>
                      <label className="halfWidthinput">
                        <p>MOBILE NUMBER</p>{" "}
                        <input
                          type="number"
                          value={Phonenum}
                          onChange={handelPhonenum}
                          placeholder="Enter Mobile Number"
                          required
                        ></input>{" "}
                        <br></br>
                        <span id="errorMessage">{phonenumError}</span>
                      </label>
                      <label className="fullWidthinput">
                        <p>House Number*</p>{" "}
                        <input
                          type="text"
                          value={house_Numbeer}
                          required
                          onChange={(e) => setHouseNumber(e.target.value)}
                          placeholder="Enter House/Flat Number"
                        ></input>
                      </label>
                      {/* <label className="halfWidthinput">
                        <p>PIN CODE</p>{" "}
                        <input
                          type="text"
                          placeholder="Enter Pin Code"
                          value={areApin}
                          onChange={handelPincode}
                          required
                        ></input>
                        {areApin && areApin !== "" && pinList && (
                          <div className="pincodeList">
                            {pincodeLoading ? (
                              "loading"
                            ) : (
                              <div>
                                {areaPincode &&
                                  areaPincode.results &&
                                  areaPincode.results
                                    .filter((pin) => {
                                      if (areApin == "") {
                                        return pin;
                                      } else if (
                                        pin.pincode
                                          .toLowerCase()
                                          .includes(areApin.toLowerCase())
                                      ) {
                                        return pin;
                                      }
                                    })
                                    .map((values, index) => {
                                      if (index < 5) {
                                        return (
                                          <li
                                            key={values.id}
                                            onClick={() =>
                                              handelPincodeList(
                                                values.pincode,
                                                values.id
                                              )
                                            }
                                          >
                                            {values.pincode}
                                          </li>
                                        );
                                      }
                                    })}
                              </div>
                            )}
                          </div>
                        )}
                      </label> */}

                      <label className="fullWidthinput">
                        <p>House Name*</p>{" "}
                        <input
                          type="text"
                          value={address_line2}
                          required
                          onChange={(e) => setAddress_line2(e.target.value)}
                          placeholder="Enter Appartment Name/Building *"
                        ></input>
                      </label>

                      <label className="fullWidthinput">
                        <p>LANDMARK</p>{" "}
                        <input
                          type="text"
                          value={street_name}
                          required
                          onChange={(e) => setstreet_name(e.target.value)}
                          placeholder="Enter Street Name Or Landmark"
                        ></input>
                      </label>

                      <label className="fullWidthinput">
                        <p>AREA/LOCALITY</p>{" "}
                        <input
                          type="text"
                          value={customer_landmark}
                          required
                          onChange={locationAutoCompleteSearch}
                          // onChange={(e) => setCostomerLandmark(e.target.value)}
                          placeholder="Enter Area/Locality"
                        ></input>
                      </label>
                      <div
                        className={
                          displayCityList
                            ? "cityList cityListMyAddress cityListFixNewAddresscss"
                            : "displayNone"
                        }
                        id="cityList"
                      >
                        {customer_landmark && cityList != []
                          ? cityList.map((values, index) => {
                              return (
                                <>
                                  <div
                                    onClick={() => setInputcity(values)}
                                    key={index}
                                    className={
                                      displayCityList
                                        ? "cityLIstLP cityListLPAddress"
                                        : "displayNone"
                                    }
                                  >
                                    <span>{values}</span>
                                  </div>
                                </>
                              );
                            })
                          : null}
                      </div>

                      <label className="halfWidthinput">
                        <p>BOOKING FOR</p>
                        <input
                          type="text"
                          value={booking_for}
                          onChange={(e) => setbooking_for(e.target.value)}
                          placeholder="Eg. Self, Parents, Children"
                          required
                        ></input>
                      </label>
                    </div>
                    <div className="addressBtn2 btn2Edit">
                      <button
                        type="submit"
                        disabled={newNameError !== "" || phonenumError !== ""}
                      >
                        SAVE ADDRESS
                      </button>
                    </div>
                  </form>
                </div>
              ) : (
                <div className="addresDetails">
                  <div className="addressboxDiv">
                    {loading ? (
                      <Loader />
                    ) : addresss &&
                      addresss.results &&
                      addresss.results.length > 0 ? (
                      addresss.results.map((values, index) => {
                        return (
                          <div className="addressBoxsubDiv" key={values.id}>
                            <div className="addressBox1">
                              <p>{values.name ? values.name : "Address"}</p>{" "}
                              <div className="deletIcon">
                                <RiDeleteBin6Line
                                  className="deletlogo"
                                  onClick={() =>
                                    deleteAddressFunnction(
                                      values !== "" && values.id
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="addressBox2">
                              <p>
                                {`${values.street_name} , ${
                                  values.house_number
                                } ${
                                  values.areapincode != null || undefined
                                    ? values.areapincode?.pincode
                                    : ""
                                } `}
                              </p>
                              {/* <p> {
                              values.areapincode
                              }</p> */}
                              <div className="actions">
                                <div
                                  className="editDiv"
                                  onClick={() => sendId(values)}
                                >
                                  <span className="editLogo">
                                    <FiEdit />{" "}
                                  </span>{" "}
                                  <p>Edit</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="" style={{ padding: "3rem" }}>
                        <h2>NO ADDRESS ADDED YET !</h2>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {showAddressForm ? null : (
                <div className="addressBtn">
                  <button type="submit" onClick={openNewform}>
                    ADD NEW ADDRESS
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  Accesstoken: state.mapMyindiaToken.accesstoken,
  LoadingAccessToken: state.mapMyindiaToken.loading,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getMapMyIndiaAccessToken: (token) => {
      dispatch(getMapMyIndiaAccessToken(token));
    },
  };
};
export default {
  component: connect(
    mapStateToProps,
    mapDispatchToProps
  )(React.memo(MyAddresses)),
};
